module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/~/core-js/modules/_fails.js
// module id = ../../../../core-js/modules/_fails.js
// module chunks = 1